import React from 'react';
import Image from 'next/image';

const InfoMessage = ({ iconSrc, message }) => {
    return (
        <div className="flex items-center py-2 px-3 gap-2.5 mt-3 rounded-md border border-[#BDE3D8] bg-[#E9FAF5]">
            <Image src={iconSrc} width={20} height={20} alt="info-icon" className="object-contain" />
            <span className="text-[#347865] text-xs font-normal leading-normal">{message}</span>
        </div>
    );
};

export default InfoMessage;
